<template>
    <div class="risk-assessment">
        <div class="risk-main">
            <div class="risk-title">
                您好！{{name}}先生/女士，感谢您对宜信普泽的信任，为维护您的权利，根据相关法规，对购买基金产品或者服务的普通投资者定期抽取一定比例进行回访，请您根据实际情况，回答以下问题：
            </div>
            <dl v-for="(item, index) in list" :key="index" ref="dl">
                <div class="tm-number">
                    <b>{{ index + 1 }}</b>
                    <span>/{{ list.length }}</span>
                </div>
                <dt>
                    <span>{{ item.title }}</span>
                </dt>
                <dd>
                    <p v-for="(subItem, subIndex) in item.options" :class="{ active: !!subItem.selected }"  @click="choose(index, subIndex)" :key="subIndex">
                        <span>{{ subItem.option + " . " + subItem.content }}</span>
                    </p>
                </dd>
            </dl>
            <div class="risk-title">
                本次回访到此结束，感谢您的配合！祝您生活愉快！
            </div>
        </div>
        <div class="bigBtn risk-foot" @click="submit">确认提交</div>
    </div>
</template>
<script>
import { callHandler, getUserInfo } from "@/utils/bridge.js";
import {decrypt} from "../../../config";
export default {
    data() {
        return {
            list: [],
            token: "",
            name: '',
            cardNo: ''
        };
    },
    async created() {
        let {token} = this.$route.query;
        if(token){
            this.token = token;
        }else{
            let userInfo = await getUserInfo();
            this.token = userInfo.token;
        }
        this.getName()
            .then(res => {
                this.name = decrypt(res.data).realName;
                this.cardNo = decrypt(res.data).idCardNo;
                const list = [
                    {
                        title: '您是'+ this.name +'先生/女士，身份证号后4位是'+ this.cardNo +'？',
                        options : [{
                            option: 'A',
                            content: '是'
                        },{
                            option: 'B',
                            content: '否'
                        }]
                    },{
                        title: '购买基金产品前，您是否已完整阅读并充分理解基金合同、风险揭示书、产品资料概要等内容，知晓基金的风险以及相关风险警示？',
                        options : [{
                            option: 'A',
                            content: '是'
                        },{
                            option: 'B',
                            content: '否'
                        }]
                    },{
                        title: '我公司根据《证券期货投资者适当性管理办法》进行投资者分类，您被认定为普通投资者，我公司会通过问卷调查的方式测试并告知其风险承受能力等级、适合购买的产品的风险等级范围。若其主动购买与其风险承受能力不匹配的产品且其不是风险承受能力最低类别的投资者时，我公司还会出具《风险不匹配警示函》。请问，您是否已知晓自己的风险承受能力等级、购买的基金产品的风险等级以及适当性匹配意见？',
                        options : [{
                            option: 'A',
                            content: '是'
                        },{
                            option: 'B',
                            content: '否'
                        }]
                    },{
                        title: '请问您是否已经阅读并了解了产品合同中所约定的管理费、托管费等费用及费率，投资者重要权利、信息披露的内容、方式和频率这些内容？',
                        options : [{
                            option: 'A',
                            content: '是'
                        },{
                            option: 'B',
                            content: '否'
                        }]
                    },{
                        title: '公募基金产品不等同于将资金作为存款存放在银行或其它存款类金融机构，公募基金管理人不保证基金一定盈利，也不保证您的资金不受损失，您对您所购买的产品未来可能出现的投资损失有清晰的了解吗？',
                        options : [{
                            option: 'A',content: '有'
                        },{
                            option: 'B',content: '没有'
                        }]
                    },{
                        title: '请问我公司的理财经理推荐基金产品时，是否有以下违规行为：（1）向您就不确定事项提供确定性的判断，或者告知您有可能误认为具有确定性的意见；（2）向您推荐高于您风险承受能力或者不符合您投资目标的产品；（3）其他损害您合法权益的行为？',
                        options : [{
                            option: 'A',content: '没有'
                        },{
                            option: 'B',content: '有'
                        }]
                    }];
                this.list = list;
            })
            .catch(e => {
                this.$toast(e);
            });
    },
    beforeMount() {},
    methods: {
        getName: async function(){
            return await this.$request({
                url: "/h5/aproproateness/userInfo.json",
                data: this.$qs.stringify({
                    token: this.token
                })
            });
        },
        choose: function(index, subIndex) {
            let temp = this.list;
            temp[index].options.forEach((item, i) => {
                i === subIndex ? (item.selected = true) : (item.selected = false);
            });
            this.$set(this.list, index, temp[index]);
            if (index < temp.length - 1) {
                //页面滚动到下一题位置
                this.scroll(index + 1);
            }
        },
        verify() {
            const len = this.list.length;
            for (let i = 0; i < len; i++) {
                let item = this.list[i];
                let options = item.options;
                let flag = false;
                for (let j = 0; j < options.length; j++) {
                    let subItem = options[j];
                    if (subItem.selected) {
                        flag = true;
                    }
                }
                if (!flag) {
                    return i;
                }
            }
            return "success";
        },
        getResult() {
            const result = {};
            for (let i=0;i<this.list.length;i++){
                let key;
                switch (i) {
                    case 0:
                        key = 'questionOne';
                        break;
                    case 1:
                        key = 'questionTwo';
                        break;
                    case 2:
                        key = 'questionThree';
                        break;
                    case 3:
                        key = 'questionFour';
                        break;
                    case 4:
                        key = 'questionFive';
                        break;
                    case 5:
                        key = 'questionSix';
                        break;
                }
                this.list[i].options.forEach(subItem => {
                    if (subItem.selected) {
                         result[key] = subItem.option;
                    }
                });
            }
            return result;
        },
        scroll(index) {
            document.documentElement.scrollTop = this.$refs.dl[index].offsetTop;
            document.body.scrollTop = this.$refs.dl[index].offsetTop;
        },
        submit: (function() {
            let flag = true;
            return function() {
                const verify = this.verify();
                if (verify !== "success") {
                    return this.scroll(verify);
                }

                const answer = this.getResult();
                answer.token = this.token;
                //提交答案
                if (flag) {
                    flag = false;
                    this.$request({
                        url: "/h5/aproproateness/save.json",
                        data: this.$qs.stringify(answer)
                    })
                        .then(res => {
                            flag = true;
                            let msg = res.code === '1'?'提交成功，感谢您的配合！祝您生活愉快！':res.msg;
                            this.$toast(msg, 2000, function () {
                                callHandler("xhWapGoBack", "wapCloseWeb");
                            });
                        })
                        .catch(e => {
                            flag = true;
                            this.$toast(e);
                        });
                }
            };
        })(),
        confirm() {}
    }
};
</script>
<style lang="less">
.risk-assessment {
    width: 100%;
    box-sizing: border-box;
    /*  .risk-head {
        width: 100%;
        height: 96px;
        background-image: linear-gradient(270deg, #2b2632 0%, #53505a 99%);
    } */
    .risk-main {
        width: 100%;
        background: #fff;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 0 16px 20px 16px;
        padding-top: 20px;
        .risk-title {
            font-size: 13px;
            color: #aaaaaa;
            line-height: 20px;
            margin-bottom: 20px;
        }
        dl {
            padding: 20px 16px;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            background: #f8f8f8;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
            .tm-number {
                display: inline-block;
                width: 56px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background-image: linear-gradient(90deg, #e0cb99 0%, #bd9c60 100%);
                border-radius: 0 23px 23px 0;
                position: absolute;
                top: 18px;
                left: 0;
                b {
                    color: #fff;
                    font-size: 16px;
                    font-weight: 400;
                }
                span {
                    font-size: 13px;
                    color: #fff;
                }
            }
            dt {
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                padding-left: 50px;
                span {
                    line-height: 24px;
                    font-size: 14px;
                    color: #333333;
                }
            }
            dd {
                p {
                    display: flex;
                    /* justify-content: center; */
                    align-items: center;
                    background: #ffffff;
                    border-radius: 20px;
                    padding: 10px 16px;
                    margin-bottom: 18px;
                    text-align: justify;
                    input {
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }

        .active {
            background-image: linear-gradient(85deg, #e0cb99 0%, #bd9c60 100%) !important;
            color: #fff !important;
        }
    }
}

</style>
